// Mapping kuota diskon per kategori buku
// Jika nama kategori berbeda tipis, pencocokan dilakukan case-insensitive

const QUOTA_MAP = {
  'buku ramadhan 2026': 20,
  'buku teks pramuka': 10,
  'buku teks terbitan 2025': 35,
  'ekonomis 2026': 40,
  'premium 2026': 45,
};

export function getCategoryDiscountQuota(categoryName) {
  if (!categoryName) return 0;
  const key = String(categoryName).trim().toLowerCase();
  const quota = QUOTA_MAP[key] ?? 0;
  
  // Debug log untuk troubleshooting
  if (quota === 0 && key) {
    console.log('⚠️ Kategori tidak ditemukan dalam mapping:', {
      originalCategory: categoryName,
      normalizedKey: key,
      availableCategories: Object.keys(QUOTA_MAP)
    });
  } else if (quota > 0) {
    console.log('✅ Kuota diskon ditemukan:', {
      category: categoryName,
      quota: quota + '%'
    });
  }
  
  return quota;
}

export default QUOTA_MAP;

